// Generated by purs version 0.15.16
import * as App_Operation_Types from "../App.Operation.Types/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
var $$delete = /* #__PURE__ */ Data_Set["delete"](App_Operation_Types.ordOperationId);
var update = /* #__PURE__ */ Data_Map_Internal.update(App_Operation_Types.ordOperationScope);
var elem = /* #__PURE__ */ Data_Array.elem(App_Operation_Types.eqOperationId);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(App_Operation_Types.ordOperationId);
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Maybe.bindMaybe);
var lookup1 = /* #__PURE__ */ Data_Map_Internal.lookup(App_Operation_Types.ordOperationScope);
var lookup2 = /* #__PURE__ */ Data_Map_Internal.lookup(Data_Ord.ordInt);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var fromFoldable = /* #__PURE__ */ Data_Array.fromFoldable(Data_Set.foldableSet);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(App_Operation_Types.ordOperationId);
var insert1 = /* #__PURE__ */ Data_Set.insert(App_Operation_Types.ordOperationId);
var alter = /* #__PURE__ */ Data_Map_Internal.alter(App_Operation_Types.ordOperationScope);
var alter1 = /* #__PURE__ */ Data_Map_Internal.alter(Data_Ord.ordInt);
var insert2 = /* #__PURE__ */ Data_Map_Internal.insert(App_Operation_Types.ordOperationScope);
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var unwrapOperationId = function (v) {
    return v;
};
var removeScopeMembership = function (scope) {
    return function (opId) {
        var update1 = function (ids) {
            var nextIds = $$delete(opId)(ids);
            var $42 = Data_Set.isEmpty(nextIds);
            if ($42) {
                return Data_Maybe.Nothing.value;
            };
            return new Data_Maybe.Just(nextIds);
        };
        return update(update1)(scope);
    };
};
var noteTerminal = function (opId) {
    return function (ids) {
        var $43 = elem(opId)(ids);
        if ($43) {
            return ids;
        };
        return Data_Array.snoc(ids)(opId);
    };
};
var nextOperationId = function (store) {
    return store.nextId + 1 | 0;
};
var reserveOperationId = function (store) {
    var opId = nextOperationId(store);
    return new Data_Tuple.Tuple(opId, {
        activeByScope: store.activeByScope,
        byGeneration: store.byGeneration,
        entries: store.entries,
        latestByScope: store.latestByScope,
        recentTerminal: store.recentTerminal,
        nextId: unwrapOperationId(opId)
    });
};
var lookupOperation = function (store) {
    return function (opId) {
        return lookup(opId)(store.entries);
    };
};
var lookupLatestInScope = function (store) {
    return function (scope) {
        return bind(lookup1(scope)(store.latestByScope))(function (opId) {
            return lookupOperation(store)(opId);
        });
    };
};
var listOperations = /* #__PURE__ */ (function () {
    var $69 = Data_Array.fromFoldable(Data_List_Types.foldableList);
    return function ($70) {
        return $69(Data_Map_Internal.values((function (v) {
            return v.entries;
        })($70)));
    };
})();
var listGenerationOperations = function (store) {
    return function (generation) {
        var v = lookup2(generation)(store.byGeneration);
        if (v instanceof Data_Maybe.Nothing) {
            return [  ];
        };
        if (v instanceof Data_Maybe.Just) {
            return Data_Array.catMaybes(map(lookupOperation(store))(fromFoldable(v.value0)));
        };
        throw new Error("Failed pattern match at App.Operation.Store (line 134, column 45 - line 136, column 83): " + [ v.constructor.name ]);
    };
};
var isScopeActive = function (store) {
    return function (scope) {
        var v = lookup1(scope)(store.activeByScope);
        if (v instanceof Data_Maybe.Nothing) {
            return false;
        };
        if (v instanceof Data_Maybe.Just) {
            return !Data_Set.isEmpty(v.value0);
        };
        throw new Error("Failed pattern match at App.Operation.Store (line 129, column 29 - line 131, column 38): " + [ v.constructor.name ]);
    };
};
var isOperationActive = function (store) {
    return function (opId) {
        var v = lookupOperation(store)(opId);
        if (v instanceof Data_Maybe.Just && v.value0.status instanceof App_Operation_Types.OperationRunning) {
            return true;
        };
        return false;
    };
};
var emptyOperationStore = {
    nextId: 0,
    entries: Data_Map_Internal.empty,
    latestByScope: Data_Map_Internal.empty,
    activeByScope: Data_Map_Internal.empty,
    byGeneration: Data_Map_Internal.empty,
    recentTerminal: [  ]
};
var deactivateEntry = function (entry) {
    return function (store) {
        return {
            nextId: store.nextId,
            entries: store.entries,
            latestByScope: store.latestByScope,
            byGeneration: store.byGeneration,
            recentTerminal: store.recentTerminal,
            activeByScope: Data_Array.foldl(function (acc) {
                return function (scope) {
                    return removeScopeMembership(scope)(entry.id)(acc);
                };
            })(store.activeByScope)(entry.scopes)
        };
    };
};
var markSuperseded = function (opId) {
    return function (store) {
        var v = lookup(opId)(store.entries);
        if (v instanceof Data_Maybe.Nothing) {
            return store;
        };
        if (v instanceof Data_Maybe.Just) {
            var nextEntry = (function () {
                if (v.value0.status instanceof App_Operation_Types.OperationSucceeded) {
                    return v.value0;
                };
                if (v.value0.status instanceof App_Operation_Types.OperationFailed) {
                    return v.value0;
                };
                return {
                    generation: v.value0.generation,
                    id: v.value0.id,
                    kind: v.value0.kind,
                    scopes: v.value0.scopes,
                    status: App_Operation_Types.OperationSuperseded.value
                };
            })();
            var baseStore = deactivateEntry(v.value0)(store);
            return {
                nextId: baseStore.nextId,
                latestByScope: baseStore.latestByScope,
                activeByScope: baseStore.activeByScope,
                byGeneration: baseStore.byGeneration,
                entries: insert(opId)(nextEntry)(baseStore.entries),
                recentTerminal: noteTerminal(opId)(baseStore.recentTerminal)
            };
        };
        throw new Error("Failed pattern match at App.Operation.Store (line 102, column 29 - line 113, column 14): " + [ v.constructor.name ]);
    };
};
var completeOperation = function (opId) {
    return function (result) {
        return function (store) {
            var v = lookup(opId)(store.entries);
            if (v instanceof Data_Maybe.Nothing) {
                return store;
            };
            if (v instanceof Data_Maybe.Just) {
                var nextEntry = (function () {
                    if (v.value0.status instanceof App_Operation_Types.OperationSuperseded) {
                        return v.value0;
                    };
                    return {
                        generation: v.value0.generation,
                        id: v.value0.id,
                        kind: v.value0.kind,
                        scopes: v.value0.scopes,
                        status: Data_Either.either(App_Operation_Types.OperationFailed.create)(Data_Function["const"](App_Operation_Types.OperationSucceeded.value))(result)
                    };
                })();
                var baseStore = deactivateEntry(v.value0)(store);
                return {
                    nextId: baseStore.nextId,
                    latestByScope: baseStore.latestByScope,
                    activeByScope: baseStore.activeByScope,
                    byGeneration: baseStore.byGeneration,
                    entries: insert(opId)(nextEntry)(baseStore.entries),
                    recentTerminal: noteTerminal(opId)(baseStore.recentTerminal)
                };
            };
            throw new Error("Failed pattern match at App.Operation.Store (line 89, column 39 - line 99, column 14): " + [ v.constructor.name ]);
        };
    };
};
var addScopeMembership = function (scope) {
    return function (opId) {
        var update1 = function (v) {
            if (v instanceof Data_Maybe.Nothing) {
                return new Data_Maybe.Just(Data_Set.singleton(opId));
            };
            if (v instanceof Data_Maybe.Just) {
                return new Data_Maybe.Just(insert1(opId)(v.value0));
            };
            throw new Error("Failed pattern match at App.Operation.Store (line 166, column 14 - line 168, column 47): " + [ v.constructor.name ]);
        };
        return alter(update1)(scope);
    };
};
var addGenerationMembership = function (generation) {
    return function (opId) {
        var update1 = function (v) {
            if (v instanceof Data_Maybe.Nothing) {
                return new Data_Maybe.Just(Data_Set.singleton(opId));
            };
            if (v instanceof Data_Maybe.Just) {
                return new Data_Maybe.Just(insert1(opId)(v.value0));
            };
            throw new Error("Failed pattern match at App.Operation.Store (line 182, column 14 - line 184, column 47): " + [ v.constructor.name ]);
        };
        return alter1(update1)(generation);
    };
};
var activateEntry = function (entry) {
    return function (store) {
        var withLatest = Data_Array.foldl(function (acc) {
            return function (scope) {
                return {
                    activeByScope: acc.activeByScope,
                    byGeneration: acc.byGeneration,
                    entries: acc.entries,
                    nextId: acc.nextId,
                    recentTerminal: acc.recentTerminal,
                    latestByScope: insert2(scope)(entry.id)(acc.latestByScope)
                };
            };
        })(store)(entry.scopes);
        var withActive = Data_Array.foldl(function (acc) {
            return function (scope) {
                return {
                    byGeneration: acc.byGeneration,
                    entries: acc.entries,
                    latestByScope: acc.latestByScope,
                    nextId: acc.nextId,
                    recentTerminal: acc.recentTerminal,
                    activeByScope: addScopeMembership(scope)(entry.id)(acc.activeByScope)
                };
            };
        })(withLatest)(entry.scopes);
        if (entry.generation instanceof Data_Maybe.Nothing) {
            return withActive;
        };
        if (entry.generation instanceof Data_Maybe.Just) {
            return {
                nextId: withActive.nextId,
                entries: withActive.entries,
                latestByScope: withActive.latestByScope,
                activeByScope: withActive.activeByScope,
                recentTerminal: withActive.recentTerminal,
                byGeneration: addGenerationMembership(entry.generation.value0)(entry.id)(withActive.byGeneration)
            };
        };
        throw new Error("Failed pattern match at App.Operation.Store (line 151, column 8 - line 154, column 110): " + [ entry.generation.constructor.name ]);
    };
};
var recordStartedOperation = function (opId) {
    return function (kind) {
        return function (generation) {
            return function (store) {
                var v = lookup(opId)(store.entries);
                if (v instanceof Data_Maybe.Just) {
                    return {
                        entries: store.entries,
                        latestByScope: store.latestByScope,
                        activeByScope: store.activeByScope,
                        byGeneration: store.byGeneration,
                        recentTerminal: store.recentTerminal,
                        nextId: max(store.nextId)(unwrapOperationId(opId))
                    };
                };
                if (v instanceof Data_Maybe.Nothing) {
                    var entry = {
                        id: opId,
                        kind: kind,
                        scopes: App_Operation_Types.operationScopes(kind)(generation),
                        generation: generation,
                        status: App_Operation_Types.OperationRunning.value
                    };
                    var reserved = {
                        activeByScope: store.activeByScope,
                        byGeneration: store.byGeneration,
                        latestByScope: store.latestByScope,
                        recentTerminal: store.recentTerminal,
                        nextId: max(store.nextId)(unwrapOperationId(opId)),
                        entries: insert(opId)(entry)(store.entries)
                    };
                    return activateEntry(entry)(reserved);
                };
                throw new Error("Failed pattern match at App.Operation.Store (line 62, column 53 - line 79, column 40): " + [ v.constructor.name ]);
            };
        };
    };
};
var startOperation = function (kind) {
    return function (generation) {
        return function (store) {
            var v = reserveOperationId(store);
            return new Data_Tuple.Tuple(v.value0, recordStartedOperation(v.value0)(kind)(generation)(v.value1));
        };
    };
};
export {
    emptyOperationStore,
    reserveOperationId,
    recordStartedOperation,
    startOperation,
    completeOperation,
    markSuperseded,
    lookupOperation,
    lookupLatestInScope,
    isOperationActive,
    isScopeActive,
    listGenerationOperations,
    listOperations
};
//# sourceMappingURL=index.js.map
